<template>
    <Card>
        <h2 class="mb-5"><i class="fas fa-pen-square"></i> {{ __('messages.create') }}</h2>

        <form id="message_form">
            <div class="form-group pt-3">
                <div class="row">
                    <div class="col-md-1 d-flex align-items-center">
                        <label>{{ __('messages.recipient') }}</label>
                    </div>
                    <div class="col-md-11 pl-5">
                        <input name="recipient" type="email" class="form-control" placeholder="E-Mail"
                               v-model="form.recipient">
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-1 d-flex align-items-center">
                        <label>{{ __('messages.subject') }}</label>
                    </div>
                    <div class="col-md-11 pl-5">
                        <input name="subject" type="text" class="form-control"
                               v-model="form.subject">
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-1 d-flex align-items-center">
                        <label>{{ __('messages.message') }}</label>
                    </div>
                    <div class="col-md-11 pl-5">
                        <rich-editor id="conditions" v-model="form.message"/>
                    </div>
                </div>
            </div>
            <div class="form-group pt-5">
                <div class="pt-3">
                    <div class="row pt-5">
                        <div class="col-1"></div>
                        <div class="col-md-11 pl-5">
                            <button class="btn btn-primary px-5" @click="submit"><i class="fas fa-paper-plane"></i> {{
                                    __('actions.send')
                                }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </Card>
</template>

<script>
import Card from '@components/Cards/Card.vue'
import FormGroupNew from '@components/Form/FormGroupNew.vue'
import RichEditor from '@components/RichTextEditor/RichEditor.vue'
export default {
    components: {FormGroupNew, Card, RichEditor},

    props: {
        returnTo: String,
        recipient: String,
        subject: String,
        placeholder: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                returnTo: this.returnTo,
                recipient: this.recipient,
                subject: this.subject,
                message: this.placeholder,
            }),
        }
    },

    methods: {
        submit() {
            this.form.post(this.$route('admin.messages.submit'))
        },
    },
}
</script>
